export default "__VITE_ASSET__TqVbFA_s__"